import * as React from "react";
import type { SVGProps } from "react";

const SvgFsaCalculator = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={65}
    height={65}
    viewBox="0 0 65 65"
    {...props}
  >
    <path
      fill="#FEEBE5"
      fillRule="evenodd"
      d="M53.182 0C59.682 0 65 5.318 65 11.818v41.364C65 59.682 59.682 65 53.182 65H11.818C5.318 65 0 59.682 0 53.182V11.818C0 5.318 5.318 0 11.818 0zm0 4.432H11.818c-4.071 0-7.386 3.315-7.386 7.386v41.364c0 4.074 3.315 7.386 7.386 7.386h41.364c4.071 0 7.386-3.312 7.386-7.386V11.818c0-4.071-3.315-7.386-7.386-7.386m-38.5 32.823a2.216 2.216 0 0 1 3.135 0l3.604 3.605 3.602-3.605a2.216 2.216 0 1 1 3.134 3.135l-3.604 3.601 3.604 3.605a2.216 2.216 0 1 1-3.134 3.135l-3.602-3.605-3.604 3.605a2.223 2.223 0 0 1-3.136 0 2.22 2.22 0 0 1 0-3.135l3.605-3.605-3.604-3.601a2.216 2.216 0 0 1 0-3.135m35.545 8.953a2.217 2.217 0 0 1 0 4.432H36.932a2.217 2.217 0 0 1 0-4.432zm0-8.864a2.217 2.217 0 0 1 0 4.432H36.932a2.217 2.217 0 0 1 0-4.432zM21.42 12.557c1.224 0 2.216.993 2.216 2.216v4.432h4.432a2.216 2.216 0 0 1 0 4.431h-4.432v4.432a2.216 2.216 0 0 1-4.431 0v-4.432h-4.432a2.216 2.216 0 0 1 0-4.431h4.432v-4.432c0-1.223.992-2.216 2.215-2.216m28.807 6.648a2.216 2.216 0 0 1 0 4.431H36.932a2.216 2.216 0 0 1 0-4.431z"
    />
  </svg>
);
export default SvgFsaCalculator;
